"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_mgr_error_1 = require("../errors/state-mgr-error");
var error_types_1 = require("../errors/error-types");
var event_bus_1 = require("@idp/event-bus");
var StateManager = /** @class */ (function () {
    function StateManager(namespace) {
        this.namespace = namespace;
    }
    /**
     * @deprecated
     */
    /* istanbul ignore next */
    StateManager.init = function (store, eventBus) {
        // console.warn('StateManager::init:: this method is deprecated...');
    };
    StateManager.setup = function (store, eventBus, postSet) {
        if (StateManager._isInitialized) {
            return;
        }
        StateManager.postSet = postSet;
        StateManager._isInitialized = true;
        StateManager._store = store;
        var observeeConfig = {
            observerableId: StateManager.observerId,
            serviceNames: [],
        };
        StateManager.eventBus = eventBus;
        StateManager.eventBus.configObserverable(observeeConfig);
    };
    StateManager.purge = function () {
        StateManager._namespaces.clear();
        StateManager._store.purge();
    };
    StateManager.buildStateProxyForNamespace = function (namespace, initialState) {
        if (!StateManager._store) {
            throw new state_mgr_error_1.StateMgrError(error_types_1.ErrorType.storeInitializationError, "error creating proxy, store wasn't found please initialize state manager with init function");
        }
        if (StateManager._namespaces.has(namespace)) {
            throw new state_mgr_error_1.StateMgrError(error_types_1.ErrorType.duplicateNamespace, "cannot create two proxies with the same namespace: " + namespace);
        }
        StateManager._namespaces.add(namespace);
        var stateManagerInstance = new StateManager(namespace);
        stateManagerInstance.initializeStore(initialState);
        return stateManagerInstance;
    };
    StateManager.restore = function (key, value) {
        if (!StateManager._allowRestore) {
            throw new Error('Using restore after bootstrapping the app is forbidden!');
        }
        if (StateManager._store.get(key)) {
            return;
        }
        StateManager._store.set(key, value);
        StateManager.eventBus.notifyObservers(StateManager.observerId, "state_management:" + key);
    };
    StateManager.lockRestore = function () {
        StateManager._allowRestore = false;
    };
    StateManager.registerSet = function (cb) {
        StateManager.onSet = cb;
    };
    StateManager.prototype.set = function (key, value) {
        if (!StateManager._namespaces.has(this.namespace)) {
            throw new state_mgr_error_1.StateMgrError(error_types_1.ErrorType.namespaceNotFound, "namespace " + this.namespace + " not found, call buildStateProxyForNamespace to request namespace instance");
        }
        if (StateManager.onSet) {
            StateManager.onSet(this.namespace, key, value);
        }
        StateManager._store.set(this.namespace + ":" + key, value);
        if (StateManager.postSet) {
            StateManager.postSet(this.namespace + ":" + key, value);
        }
        StateManager.eventBus.notifyObservers(StateManager.observerId, "state_management:" + this.namespace + ":" + key);
    };
    StateManager.prototype.initializeStore = function (initialStore) {
        for (var key in initialStore) {
            var value = initialStore[key];
            this.set(key, value);
        }
    };
    StateManager.prototype.getForProxy = function (key) {
        return StateManager._store.get(this.namespace + ":" + key);
    };
    StateManager.prototype.get = function (namespace, key) {
        return StateManager._store.get(namespace + ":" + key);
    };
    StateManager.prototype.remove = function (key) {
        StateManager._store.remove(this.namespace + ":" + key);
    };
    StateManager.observerId = event_bus_1.ICCEventBusManager.getUUID();
    StateManager._isInitialized = false;
    StateManager._namespaces = new Set();
    StateManager._allowRestore = true;
    return StateManager;
}());
exports.StateManager = StateManager;
//# sourceMappingURL=state-manager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/state-manager/state-manager.js
// module id = 336
// module chunks = 8